
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/dailyRateSplit',['Vue', 'vue!../reusableComponents/segment'],function(Vue, segment){
        return {
            name:'dailyRateSplit',
            template:template,
            components: {
                segment: segment
            },
            computed: {
                dailyRates: function() {
                   return this.$store.state.pmsCheckin.dailyRates;
                }
            }
        }
    })
})('<segment> <template v-slot:header> <i class="fas fa-calendar-check"></i> {{localization.roomReservation.pmsCheckIn.rateSplitHeader}} </template> <template v-slot:body> <table class="table table-bordered"> <thead class="blueText"> <tr> <th v-for="rate in dailyRates" :key="rate.PMSDate">{{formatDate(rate.PMSDate, \'MMM D\')}}<p>{{localization.roomReservation.pmsCheckIn.pmsRateType+" "}} {{rate.PMSRateType}}</p></th> </tr> </thead> <tbody> <tr> <td v-for="rate in dailyRates" :key="rate.PMSDate+\'td\'">{{rate.NetRate}}</td> </tr> </tbody> </table> </template> </segment>');
